angular.module('bribac.entities.organizationFactory', [])

  .value('organizationFactory', function organizationFactory(data) {
    return angular.merge({
      id: null,
      name: null,
      number: null,
      bacUnit: 'BAC_PERCENT',
      settings: null,
    }, data)
  })
